module.exports = __webpack_public_path__ + "static/img/company-6.b894c731.png";